export function parseMessages(message: string) {
  switch (message) {
    case 'User cancelled login or did not fully authorize.':
      return 'Ha cancelado el inicio de sesión por favor inténtelo nuevamente';

    default:
      return message;
  }
}
